import React from "react"
import { useGetMedicalInfo, useMedicalInfo } from "../../context/MedicalInfoContext"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import { SmokeDrinkOptions } from "./MedicalInfoOptions"
import {
  StepLayout,
  ButtonFooterLayout,
  ContinueButton,
  SkipButton,
  RoutingFlowCheckboxGroup,
  useConvertTranslatedLabel,
  RoutingFlowTitle
} from "#/components/carrot-plans/shared"
import { FormattedMessage, useIntl } from "react-intl"
import { Form } from "@carrotfertility/carotene-core-x"

type FormValues = {
  smokeDrink?: string[]
}

export default function SmokeDrinkStep(): JSX.Element {
  const intl = useIntl()
  const { updateMedicalInfo, hasQuestionBeenSkipped } = useMedicalInfo()
  const { data: medicalInfo } = useGetMedicalInfo()
  const defaultValue = medicalInfo?.smokeDrink

  const { send } = useStateMachine(defaultValue || hasQuestionBeenSkipped("smokeDrink") ? "" : null)

  const options = useConvertTranslatedLabel(SmokeDrinkOptions)

  async function onClickContinue(values: FormValues): Promise<void> {
    await updateMedicalInfo({ smokeDrink: values?.smokeDrink })
    send("")
  }

  async function onSkip(): Promise<void> {
    await updateMedicalInfo({ skipFields: ["smokeDrink"] })
    send("")
  }

  const header = intl.formatMessage({
    defaultMessage: "Select any that apply."
  })

  return (
    <>
      <RoutingFlowTitle title={header} />
      <StepLayout
        header={<span id="smokeDrink-label">{header}</span>}
        formElements={
          <Form
            defaultValues={{
              smokeDrink: defaultValue || []
            }}
            onSubmit={onClickContinue}
          >
            <RoutingFlowCheckboxGroup name="smokeDrink" aria-labelledby="smokeDrink-label" options={options} />
            <ButtonFooterLayout
              continueButton={
                <ContinueButton>
                  <FormattedMessage defaultMessage="Continue" />
                </ContinueButton>
              }
              skipButton={<SkipButton onClick={onSkip} />}
            />
          </Form>
        }
      />
    </>
  )
}
